var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 9C0.75 8.48223 1.16973 8.0625 1.6875 8.0625H22.3125C22.8303 8.0625 23.25 8.48223 23.25 9C23.25 9.51777 22.8303 9.9375 22.3125 9.9375H1.6875C1.16973 9.9375 0.75 9.51777 0.75 9Z",
    fill: "#7871DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 1.5C0.75 0.982233 1.16973 0.5625 1.6875 0.5625H22.3125C22.8303 0.5625 23.25 0.982233 23.25 1.5C23.25 2.01777 22.8303 2.4375 22.3125 2.4375H1.6875C1.16973 2.4375 0.75 2.01777 0.75 1.5Z",
    fill: "#7871DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 16.5C0.75 15.9822 1.16973 15.5625 1.6875 15.5625H22.3125C22.8303 15.5625 23.25 15.9822 23.25 16.5C23.25 17.0178 22.8303 17.4375 22.3125 17.4375H1.6875C1.16973 17.4375 0.75 17.0178 0.75 16.5Z",
    fill: "#7871DE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.19805978e593596a08c4a67e66822565.svg";
export { ForwardRef as ReactComponent };